import { EndpointSetting } from "@/constants/app/type";
import { FlightState } from "../type";

export const callbackCampaignBanners: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  state.campaign_list.loading = false
  state.campaign_list.error = null
  state.campaign_list.success = true
  state.campaign_list.data = action.payload?.data
}